export const ALERTS = 'ALERTS'
export const REMOVE_ALERTS = 'REMOVE_ALERTS'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const GETPROFILE = 'GETPROFILE'
export const GET2FACODE = 'GET2FACODE'
export const HANDLE_WALLET = "HANDLE_WALLET"
export const DISCONNECT_WALLET = "DISCONNECT_WALLET"
export const WALLET_NOT_FOUND = "WALLET_NOT_FOUND"
export const ADD_NEW_WALLET = "ADD_NEW_WALLET"
export const SET_USER_WALLETS = "SET_USER_WALLETS"
export const SET_CURRENT_WALLET = "SET_CURRENT_WALLET"
export const UPDATE_WALLET_BALANCE = "UPDATE_WALLET_BALANCE"
export const UPDATE_GAS_BALANCE = "UPDATE_GAS_BALANCE";
export const SET_WEB3_PROVIDER = "SET_WEB3_PROVIDER"
export const SET_WEB3 = "SET_WEB3"
export const SET_CHAIN_AND_NETWOR_ID = "SET_CHAIN_AND_NETWOR_ID"
export const SET_CONNECTOR_NAME="SET_CONNECTOR_NAME"
export const OPEN_BUY_GAINS_MODEL = "OPEN_BUY_GAINS_MODEL"
export const OPEN_GAINS_CONFIRMATION_MODEL = "OPEN_GAINS_CONFIRMATION_MODEL"

export const GET_SCORE = "GET_SCORE";
export const TOTAL_ATTEMPT = "TOTAL_ATTEMPTS";
export const TOTAL_QUESTIONS = "TOTAL_QUESTIONS";
export const HANDLE_NEXT_QUESTION = "HANDLE_NEXT_QUESTION";
export const HANDLE_SELECTED_ANSWER =  "HANDLE_SELECTED_ANSWER";
export const HANDLE_CORRECT_ANSWER = "HANDLE_CORRECT_ANSWER";
export const HANDLE_WRONG_ANSWER = "HANDLE_WRONG_ANSWER";
export const HANDLE_CORRECT_ANSWER_SCORE= "HANDLE_CORRECT_ANSWER_SCORE";
export const HANDLE_QUESTION_SCORE = "HANDLE_QUESTION_SCORE";
export const HANDLE_RESULT_COMPONENT ="HANDLE_RESULT_COMPONENT";
export const GET_QUIZ_DATA = "GET_QUIZ_DATA";
export const CLEAR_ATTEMPT_STATE = "CLEAR_ATTEMPT_STATE";
export const HANDLE_NEXT_VIDEO = "HANDLE_NEXT_VIDEO";
export const REMOVE_ATTEMPT_STATE ="REMOVE_ATTEMPT_STATE";
export const HANDLE_VIDEO_COMPLETION ="HANDLE_VIDEO_COMPLETION";
export const TIMER_EXPIRED = "TIMER_EXPIRED";
export const USER_TOTAL_SCORE = "USER_TOTAL_SCORE";
export const SCORE_PERCENTAGE = "SCORE_PERCENTAGE";
export const REWARD_TICKETS = "REWARD_TICKETS";
export const STATE_REMOVER = "STATE_REMOVER";

export const ADD_POOL = "ADD_POOL";
export const ADD_POOLS = "ADD_POOLS";
export const UPDATE_POOL_CONTRIBUTION = "UPDATE_POOL_CONTRIBUTION";
export const UPDATE_POOL_STATE = "UPDATE_POOL_STATE";
export const SET_POOL_STATUS = "SET_POOL_STATUS";
export const SET_ACTIVE_POOL = "SET_ACTIVE_POOL";
export const UNSET_ACTIVE_POOL = "UNSET_ACTIVE_POOL";
export const SET_LIVE_POOLS = "SET_LIVE_POOLS";
export const UPDATE_LIVE_POOLS = "UPDATE_LIVE_POOLS";
export const UPDATE_CLOSED_POOLS = "UPDATE_CLOSED_POOLS";
export const SET_CLOSED_POOLS = "SET_CLOSED_POOLS";
export const UPDATE_USER_PLEDGE = "UPDATE_USER_PLEDGE";
export const SET_QUIZ_DATA = "SET_QUIZ_DATA";
export const ADD_QUIZ_TRACKER = "ADD_QUIZ_TRACKER";

export const ADD_ACTIVE_QUIZZES="ADD_ACTIVE_QUIZZES";
export const ADD_POOL_QUIZZES="ADD_POOL_QUIZZES";
export const UPDATE_QUIZ_QUESTION_DETAIL="UPDATE_QUIZ_QUESTION_DETAIL";
export const UPDATE_QUIZ_TRACKER="UPDATE_QUIZ_TRACKER";
export const UPDATE_ACTIVE_QUIZ_SUBMISSIONS="UPDATE_ACTIVE_QUIZ_SUBMISSIONS";
export const START_QUIZ="START_QUIZ";
export const SET_NEXT_QUESTION="SET_NEXT_QUESTION";
export const UPDATE_QUIZ_INDEX="UPDATE_QUIZ_INDEX";
export const UPDATE_QUESTION_DETAIL="UPDATE_QUESTION_DETAIL";
export const RESET_LEARN_STATE="RESET_LEARN_STATE";
export const RESET_QUIZ_STATE="RESET_QUIZ_STATE";
export const SET_QUIZ_INDEX="SET_QUIZ_INDEX";
export const CLEAR_PREVIOUS_ATTEMPT="CLEAR_PREVIOUS_ATTEMPT";
export const UPDATE_ACTIVE_QUIZZES="UPDATE_ACTIVE_QUIZZES";
export const SET_QUIZ_STATUS_AND_START_TIME="SET_QUIZ_STATUS_AND_START_TIME";
export const SET_QUIZ_STATUS="SET_QUIZ_STATUS";
export const ADD_USER_PLEDGE="ADD_USER_PLEDGE";
